import { RouterView } from "vue-router";
import scanRoutes from "@scan/router";
import { STADES } from "@/modules/histoire/chapitres";

const routes = [
  {
    path: "animax",
    name: "collection-route",
    component: RouterView,
    children: [
      {
        path: "",
        name: "home-route",
        component: () => import("./views/Collection.vue"),
        meta: { title: "My collection" },
        children: scanRoutes,
      },
      {
        path: ":id",
        name: "animax-card-route",
        component: () => import("./views/AnimaxCard.vue"),
        props: true,
        meta: { title: "Animax Nº" },
      },
      {
        // Lecteur d'épisodes (C2, 25/09) : chapitre 1 à 4, ouvert à N âmes.
        path: ":id/histoire/:chapitre",
        name: "histoire-route",
        component: () => import("@/modules/histoire/Lecteur.vue"),
        props: true,
        meta: { title: "Histoire Nº", hideMenu: true },
        // A10 (D6, audit Recette) : /histoire/9 ou /histoire/abc affichaient
        // « Chapitre NaN ». Hors 1..4, retour à la fiche de l'animal.
        beforeEnter: (to) => {
          const n = Number(to.params.chapitre);
          if (Number.isInteger(n) && n >= 1 && n <= STADES.length) return true;
          return { name: "animax-card-route", params: { id: to.params.id } };
        },
      },
    ],
  },
  {
    path: "/collection/:id",
    name: "friend-collection-route",
    component: () => import("./views/FriendCollection.vue"),
    props: true,
    meta: { title: "Friend Collection " },
  },
];

export default routes;
